import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip, TooltipPosition } from '@angular/material/tooltip';
import { IconComponent } from '@libs/components/icons';
import { ButtonStyle, ButtonType } from '@libs/common/models';
import { ComponentsIconsStyle, IconName } from '@libs/shared/models';

@Component({
  selector: 'ui-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    NgTemplateOutlet,
    MatBadge,
    IconComponent,
    MatTooltip,
  ],
})
export class ButtonComponent {
  public clicked: OutputEmitterRef<MouseEvent> = output();

  public type: InputSignal<ButtonType> = input<ButtonType>('button');
  public buttonStyle: InputSignal<ButtonStyle> = input<ButtonStyle>('filled');
  public disabled: InputSignal<boolean> = input<boolean>(false);
  public icon: InputSignal<IconName | undefined> = input();
  public iconStyle: InputSignal<ComponentsIconsStyle> = input<ComponentsIconsStyle>('solid');
  public big: InputSignal<boolean> = input<boolean>(false);
  public small: InputSignal<boolean> = input<boolean>(false);
  public loading: InputSignal<boolean> = input<boolean>(false);
  public badge: InputSignal<string> = input<string>('');
  public name: InputSignal<string> = input<string>('');
  public tooltipPosition: InputSignal<TooltipPosition> = input<TooltipPosition>('below');
  public tooltip: InputSignal<string> = input<string>('');
}
